import '../styles/dot-pulse.scss';

export default function DotPulse() {
    return (
        <div className="dot-pulse"></div>
    );
}